const SEGMENT_TYPE_TO_LINK_TYPE = {
    links: "link",
    banners: "banner"
};

const segmentLinkIds = (segment) => {
    if (Array.isArray(segment?.links)) {
        return segment.links.map((link) => link?.id).filter(Boolean);
    }
    if (Array.isArray(segment?.linkIds)) {
        return segment.linkIds.filter(Boolean);
    }
    return [];
};

// Publicado = estar en al menos un bloque (regla 7): ids distintos por tipo de
// Link. Acepta `links[].id` (GET /bo/catalog) y `linkIds` (snapshot guardado).
export const publishedLinkIds = (segments = []) => {
    const result = { link: new Set(), banner: new Set() };
    (segments || []).forEach((segment) => {
        const linkType = SEGMENT_TYPE_TO_LINK_TYPE[segment?.type];
        if (!linkType) return;
        segmentLinkIds(segment).forEach((id) => result[linkType].add(id));
    });
    return result;
};
